import React from 'react';
import { CloseIcon } from '@yme/assets/icons';
import { Image } from '@yme/atoms/image';
import { ImageErrorPlaceholder } from '@yme/atoms/image-error-placeholder';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { Tooltip } from '@yme/atoms/tooltip';
import { CardProductPriceBlock } from '@yme/common/components/molecules/cards/card-product';
import { Link } from '@yme/components/Link';
import { useWindowSize } from '@yme/hooks/index';
import { FavoriteCardButton } from '@yme/molecules/cards';
import { ProductLabel } from '@yme/molecules/product-label';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel2, RegularTextLevel3 } from '@yme/tokens/typography';
import { AspectRatio } from '@yme/utils/constants';
import { getPricesValues } from '@yme/utils/formatPrice';
import { buildImageProps } from './helpers';
import { AccessoryStyled, PreviewStyled, RemoveButton } from './styled';
export function AccessoriesCard(props) {
    const { isRightToLeft, language, fallbackImageAltText, onRemove, onLike, isLiked, cardProps: { images, prices, name, cardUrl = '', embargoExternal, daysToShowNew, isLabelFromVisible, }, } = props;
    const { isMobileView } = useWindowSize();
    const { t } = useTranslation();
    const { priceValue, discountedValue } = getPricesValues({
        prices,
        language,
    });
    const isVariantDiscounted = Boolean(discountedValue);
    const title = isMobileView ? (React.createElement(RegularTextLevel3, { color: colorCoreBlack900Base, weight: 500 }, name)) : (React.createElement(RegularTextLevel2, { color: colorCoreBlack900Base, weight: 500 }, name));
    const imageProps = buildImageProps(images[0]);
    return (React.createElement(AccessoryStyled, { as: cardUrl ? Link : 'div', to: cardUrl, "data-testid": "AccessoriesCard" },
        React.createElement(PreviewStyled, null,
            React.createElement(FavoriteCardButton, { onLike: onLike, isLiked: isLiked }),
            React.createElement(Image, { ...imageProps, placeholderComponent: React.createElement(ImageErrorPlaceholder, { aspectRatio: AspectRatio.Square, hasBackground: true, fallbackImageAltText: fallbackImageAltText }) }),
            onRemove && (React.createElement(Tooltip, { title: t('wishlist_buttonTooltipToRemoveItem_label') },
                React.createElement(RemoveButton, { type: "button", onClick: onRemove },
                    React.createElement(SVGIcon, { type: CloseIcon })))),
            React.createElement(ProductLabel, { isMobileView: isMobileView, isRightToLeft: isRightToLeft, 
                // Props of necessary labels
                isSaleLabelNeeded: isVariantDiscounted, 
                // for (New label)
                embargoExternal: embargoExternal, daysToShowNew: daysToShowNew })),
        React.createElement(FlexWrapper, { mt: "12px" }, title),
        priceValue && (React.createElement(CardProductPriceBlock, { price: priceValue, isRightToLeft: isRightToLeft, discount: discountedValue, isLabelFromVisible: isLabelFromVisible }))));
}
AccessoriesCard.displayName = 'AccessoriesCard_Molecule';
